import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  display: inline;
  cursor: pointer;
  svg {
    transition: none;
    position: relative;
    cursor: default;
    width: 16px;
    height: 16px;
    top: -1px;
    margin: 0 5px;
    right: 0;
    opacity: 0.19;
  }
`;
